module.exports = __webpack_public_path__ + "media/images/separate-meals-535fd99dc028e7f76873376fd02b3c40.svg";